import {db,auth, storage} from '../../firebase'
import {useEffect, useState} from 'react'
import { nanoid } from 'nanoid'
import {useNavigate} from 'react-router-dom'
import {collection, addDoc} from "firebase/firestore"
import {ref, uploadBytes, getDownloadURL } from 'firebase/storage'
//import {useForm} from "react-hook-form"
//import { DateTime } from "luxon";
//import moment from "moment";
//import 'moment/locale/es';

const Create = () => {
    const [nomb, setNombr] = useState("");
    const [categoria, setCategoria] = useState('')
    const [subcategoria, setSubcategoria] = useState('')
    const [precio, setPrecio] = useState('0')
    const [stock, setStock] = useState('0')
    const [fecha, setFecha] = useState(Date.now())
    const [descripcion, setDescripcion] = useState('')
    const [altura, setAltura] = useState('0')
    const [anchura, setAnchura] = useState('0')

    //const {register, handleSubmit, formState: {errors}, setError} = useForm();;

    const [imagen, setImagen] = useState(null)
    const [imagenURL, setImagenURL] = useState("")

    useEffect(() =>{
        if (imagen == null) return;
        const imageRef = ref(storage, `products/${categoria}/${nanoid(6)+ '_' + imagen.name}`)
        uploadBytes(imageRef,imagen).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {      
            //console.log('URL de imagen: ', url)
            setImagenURL(url)        
        });
        });
        //console.log("archivo cargado", imageList)
    }, [imagen]);
    
    const navigate = useNavigate()
    
    const productsCollection = collection(db, 'productos')

    const store = async (e) => {
       
        e.preventDefault()
        await addDoc(productsCollection, {
            id_user: auth.currentUser.uid,
            id: nanoid(6),
            nombre: nomb,
            categoria: categoria,
            subcategoria: subcategoria,
            descripcion: descripcion,
            precio: precio,
            altura: altura,
            anchura: anchura,
            imagen: imagenURL,
            stock: stock, 
            fecha: fecha
        })   
        //console.log(e.target)
        navigate('/admin')
        //uploadImagen()
        //archivoHandler()
    }
    return (
        <div className="container form">
                    <h1>Crear producto</h1>

                    <form onSubmit={store}>
                            <div className="mb-3">
                                <label>Nombre</label>
                                <input 
                                    type="text" 
                                    className='form-control' 
                                    value={nomb}
                                    onChange={(e) => setNombr(e.target.value)}
                                    required
                                    //{...register("nombre", { required: true})}    
                                />    
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Categoría</label>
                                <select className="form-control" id="categoria" name="categoria" onChange={(e) => setCategoria(e.target.value)} value={categoria} required>
                                    <option>Elegir...</option>
                                    <option value="alabastro">Alabastro</option>
                                    <option value="cristal">Cristal</option>
                                    <option value="murano">Murano</option>
                                    <option value="poliresina">Poliresina</option>
                                    <option value="porcelana">Porcelana</option>
                                    <option value="manteleria">Manteleria/Cojines</option>
                                    <option value="flores">Flores artificiales</option>
                                    <option value="religion">Figuras religion</option>
                                    <option value="navidad">Navidad</option>
                                    <option value="general">General</option>
                                </select>
                            </div>
                            {
                                 categoria === 'navidad' ? (
                                <>
                                    <div className="mb-3">
                                        <label className="form-label">Categoría de Navidad🌲</label>
                                        <select className="form-control" id="subcategoria" name="subcategoria" onChange={(e) => setSubcategoria(e.target.value)} value={subcategoria} required>
                                            <option value="nacimientos">Nacimientos</option>
                                            <option value="adornosmusicales">Adorno musical</option>
                                            <option value="manteleria">Mantelería</option>
                                            <option value="cojines">Cojines</option>
                                            <option value="centroycoronas">Centro de mesa o coronas</option>
                                            <option value="farolesyvelas">Faroles y Velas</option>                                       
                                            <option value="adornosarbol">Adornos para árbol</option>
                                            <option value="acrilico">Acrilico</option>
                                            <option value="cascanueces">Cascanueces</option>
                                        </select>
                                    </div>
                                </>
                                ):(
                                    <div className="mb-3">
                                        <label className="form-label">Sub-Categoría</label>
                                        <select className="form-control" id="subcategoria" name="subcategoria" onChange={(e) => setSubcategoria(e.target.value)} value={subcategoria} required>
                                            <option>Elegir...</option>
                                            <option value="alabastro">Alabastro</option>
                                            <option value="cristal">Cristal</option>
                                            <option value="murano">Murano</option>
                                            <option value="poliresina">Poliresina</option>
                                            <option value="porcelana">Porcelana</option>
                                            <option value="manteleria">Manteleria/Cojines</option>
                                            <option value="flores">Flores artificiales</option>
                                            <option value="religion">Figuras religion</option>
                                            <option value="navidad">Navidad</option>
                                            <option value="general">General</option>
                                        </select>
                                    </div>
                                )  
                            }
                        <div className="mb-3">
                            <label className="form-label">Precio ( S./ )</label>
                            <input 
                                type="number" 
                                className="form-control" 
                                value={precio}
                                onChange={(e) => setPrecio(e.target.value)}    
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Stock unidades</label>
                            <input 
                                type="number" 
                                className="form-control" 
                                value={stock}
                                onChange={(e) => setStock(e.target.value)}    
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Alto ( cm )</label>
                            <input 
                                type="number" 
                                className="form-control" 
                                value={altura}
                                onChange={(e) => setAltura(e.target.value)}    
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Ancho ( cm )</label>
                            <input 
                                type="number" 
                                className="form-control" 
                                value={anchura}
                                onChange={(e) => setAnchura(e.target.value)}    
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Descripción</label>
                            <textarea 
                                className="form-control" 
                                value={descripcion}
                                onChange={(e) => setDescripcion(e.target.value)}    
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Imagen</label>
                            <input
                                type='file'
                                className="form-control" 
                                onChange={(e) => setImagen(e.target.files[0])}        
                                
                            />
                        </div>
                        <button type='submit' className='btn btn-info'>Registrar</button>
                    </form>
        </div>
  )
}

export default Create